var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewVideoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6637",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220.9 166.9",
    style: {
      enableBackground: "new 0 0 220.9 166.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000089545768621236613340000012067160855699626145_);}\r\n\t.st1{fill:#0055A4;}\r\n\t.st2{fill:#272626;}\r\n\t.st3{fill:#EFEFEF;}\r\n\t.st4{fill:#BFC0E1;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 13.3,
    width: 185.5,
    height: 165.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036950953867815851670000016215764026050668928_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6636_00000038390962562236445070000016477632617860400297_",
    style: {
      clipPath: "url(#SVGID_00000036950953867815851670000016215764026050668928_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13421_00000023265884929640308100000016573446737894983063_",
    className: "st1",
    d: "M184.2,124.7H27.8 c-8,0-14.5-6.5-14.5-14.5V14.5c0-8,6.5-14.5,14.5-14.5c0,0,0,0,0,0h156.5c8,0,14.5,6.5,14.5,14.5c0,0,0,0,0,0v95.7 C198.7,118.2,192.2,124.7,184.2,124.7C184.2,124.7,184.2,124.7,184.2,124.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13422_00000053528374899480346640000012731926102690375300_",
    className: "st2",
    d: "M147.4,62.3 c0,22.9-18.6,41.4-41.4,41.4S64.6,85.2,64.6,62.3c0-22.9,18.6-41.4,41.4-41.4C128.9,20.9,147.4,39.5,147.4,62.3 C147.4,62.3,147.4,62.3,147.4,62.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13423_00000157271070652253465030000017140908436239630014_",
    className: "st3",
    d: "M90.8,62.3v-18c0-2.4,2-4.4,4.4-4.4 c0.8,0,1.5,0.2,2.2,0.6l15.6,9l15.6,9c2.1,1.2,2.8,3.9,1.6,6c-0.4,0.7-0.9,1.2-1.6,1.6l-15.6,9l-15.6,9c-2.1,1.2-4.8,0.5-6-1.6 c-0.4-0.7-0.6-1.4-0.6-2.2L90.8,62.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13424_00000147192073238755117000000001273071688521169316_",
    className: "st4",
    d: "M193.5,148.7H18.9 c-1.8,0-3.3-1.5-3.3-3.3l0,0v-10.1c0-1.8,1.5-3.3,3.3-3.3h174.5c1.8,0,3.3,1.5,3.3,3.3v10.1C196.8,147.2,195.3,148.7,193.5,148.7 L193.5,148.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13425_00000036954173697775484690000000609429128692495266_",
    className: "st4",
    d: "M108,165.3H18.9 c-1.8,0-3.3-1.5-3.3-3.3l0,0v-5c0-1.8,1.5-3.3,3.3-3.3c0,0,0,0,0,0H108c1.8,0,3.3,1.5,3.3,3.3v5 C111.3,163.8,109.8,165.3,108,165.3C108,165.3,108,165.3,108,165.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewVideoImg);
export default __webpack_public_path__ + "static/media/view-video-img.5fe9fef225850fe7211dff394c15b701.svg";
export { ForwardRef as ReactComponent };